export default __webpack_public_path__ + "static/media/RD-1.07d74a66.jpg";